var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _circle4, _path5, _rect, _rect2, _rect3, _rect4, _path6, _circle5, _circle6, _circle7, _path7, _ellipse, _ellipse2, _circle8, _path8, _path9, _path10, _path11, _path12, _ellipse3, _ellipse4, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _path13, _path14, _path15, _ellipse5, _rect5, _rect6, _rect7, _path16, _path17, _path18, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIlError280Px = function SvgIlError280Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 281,
    height: 169,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M250.679 154.757c-12.264 9.618-10.581-2.571-20.214-14.861-3.911-6.15-14.267-20.788-18.412-26.783-7.576-13.654-16.826-13.85-3.195-21.408 19.047-14.827 41.78-2.688 51.209 11.527 9.388 14.154 8.977 39.343-9.388 51.525Z",
    fill: "#51795C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.327 86.349a49.389 49.389 0 0 0-7.05 4.43 43.117 43.117 0 0 1 4.213 2.787c4.664 3.483 8.936 8.025 12.544 13.112 3.965-4.198 6.219-8.19 7.071-10.472.647.611 1.269 1.236 1.866 1.874-1.205 2.699-3.64 6.629-7.531 10.658a69.585 69.585 0 0 1 2.749 4.563c3.895 7.064 6.522 14.748 7.228 21.953 4.001-3.949 6.481-7.837 7.693-10.435a41.052 41.052 0 0 1-.417 5.557c-1.71 2.498-4.05 5.305-7.091 8.059.068 3.992-.514 7.81-1.888 11.219a33.66 33.66 0 0 1-6.035 5.103 38.12 38.12 0 0 1-.553.426c3.849-3.668 5.744-8.78 6.01-14.655a51.853 51.853 0 0 1-9.837 6.14l-1.055-2.199a49.151 49.151 0 0 0 10.883-7.101c-.353-7.312-2.952-15.412-7.075-22.889a66.837 66.837 0 0 0-2.387-3.995c-3.356 3.136-7.611 6.232-12.871 8.755l-1.055-2.2c5.182-2.486 9.325-5.546 12.546-8.608-3.529-5.042-7.714-9.52-12.255-12.91a39.82 39.82 0 0 0-4.811-3.099c-6.469 5.463-9.884 11.304-10.929 14.196l-2.294-.829c1.141-3.157 4.56-8.998 10.848-14.54-4.176-1.857-8.476-2.688-12.714-2.201l-.021-.184a30.935 30.935 0 0 1 4.971-2.26c3.352.349 6.655 1.373 9.834 2.919a51.25 51.25 0 0 1 5.901-4.025c1.186.222 2.358.508 3.512.85Z",
    fill: "#8BBA98"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.606 150.998c11.637 10.367 10.721-1.903 21.105-13.565 4.288-5.894 15.54-19.854 20.054-25.577 8.416-13.153 17.66-12.769 4.53-21.166-18.081-15.992-41.53-5.3-51.83 8.296-10.258 13.539-11.425 38.704 6.14 52.012Z",
    fill: "#51795C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.217 83.56a49.352 49.352 0 0 1 6.758 4.865 43.074 43.074 0 0 0-4.379 2.517c-4.873 3.184-9.42 7.449-13.34 12.3-3.695-4.438-5.694-8.563-6.402-10.894a43.455 43.455 0 0 0-1.98 1.753c1.034 2.769 3.218 6.844 6.85 11.109a69.422 69.422 0 0 0-3.03 4.381c-4.33 6.807-7.433 14.311-8.59 21.458-3.745-4.192-5.976-8.228-7.023-10.896a41.088 41.088 0 0 0 .067 5.571c1.551 2.601 3.71 5.549 6.572 8.488-.317 3.98.025 7.826 1.182 11.315a33.646 33.646 0 0 0 5.704 5.471c.178.158.353.311.525.459-3.611-3.901-5.182-9.122-5.08-15.002a51.869 51.869 0 0 0 9.433 6.745l1.19-2.129a49.153 49.153 0 0 1-10.416-7.769c.81-7.276 3.911-15.197 8.494-22.401a67.09 67.09 0 0 1 2.633-3.838c3.153 3.34 7.206 6.697 12.297 9.544l1.191-2.129c-5.016-2.805-8.959-6.119-11.982-9.377 3.838-4.811 8.296-9.017 13.04-12.117a39.865 39.865 0 0 1 4.995-2.791c6.115 5.857 9.157 11.901 10.018 14.853l2.342-.684c-.94-3.223-3.988-9.266-9.916-15.191 4.284-1.593 8.628-2.153 12.827-1.4l.033-.183a30.954 30.954 0 0 0-4.82-2.567c-3.367.138-6.727.953-9.997 2.297a51.301 51.301 0 0 0-5.638-4.386c-1.197.147-2.384.359-3.558.629Z",
    fill: "#8BBA98"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.442,
    cy: 12.442,
    transform: "matrix(-1 0 0 1 119.322 82.44)",
    fill: "#513520",
    r: 12.442
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.442,
    cy: 12.442,
    transform: "matrix(-1 0 0 1 88.094 81.708)",
    fill: "#513520",
    r: 12.442
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.442,
    cy: 12.442,
    transform: "matrix(-1 0 0 1 88.094 81.708)",
    fill: "#000",
    fillOpacity: 0.4,
    r: 12.442
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.442,
    cy: 12.442,
    transform: "matrix(-1 0 0 1 137.62 89.76)",
    fill: "#513520",
    r: 12.442
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M251.676 139.773c1.485 18.662-11.967 23.065-30.664 24.547-8.753-.169-16.284-.075-25.037.094-18.697-1.482-36.663-5.979-35.178-24.641-2.195-28.91 26.681-45.622 47.17-45.622 20.402 0 43.709 19.151 43.709 45.622ZM123.466 139.773c1.485 18.662-11.967 23.065-30.664 24.547-8.753-.169-16.284-.075-25.037.094-18.697-1.482-36.663-5.979-35.178-24.641-2.195-28.91 26.681-45.622 47.17-45.622 20.402 0 43.709 19.151 43.709 45.622Z",
    fill: "#000"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 189.83,
    y: 81.31,
    width: 19.517,
    height: 28.544,
    rx: 9.759,
    transform: "rotate(-7.447 189.83 81.31)",
    fill: "#FFEFE6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 189.83,
    y: 81.31,
    width: 19.517,
    height: 28.544,
    rx: 9.759,
    transform: "rotate(-7.447 189.83 81.31)",
    fill: "url(#il_error_280px_svg__a)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 74.283,
    y: 77.073,
    width: 19.517,
    height: 28.544,
    rx: 9.759,
    transform: "rotate(6.571 74.283 77.073)",
    fill: "#FFEFE6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 74.283,
    y: 77.073,
    width: 19.517,
    height: 28.544,
    rx: 9.759,
    transform: "rotate(6.571 74.283 77.073)",
    fill: "url(#il_error_280px_svg__b)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M144.847 57.658c-1.162 5.042 1.984 10.07 7.026 11.232l4.207-18.258a9.369 9.369 0 0 0-11.233 7.026Z",
    fill: "#FFEFE6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.59,
    cy: 16.59,
    transform: "matrix(-1 0 0 1 138.108 21.692)",
    fill: "#513520",
    r: 16.59
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.59,
    cy: 16.59,
    transform: "matrix(-1 0 0 1 141.523 42.673)",
    fill: "#513520",
    r: 16.59
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.59,
    cy: 16.59,
    transform: "matrix(-1 0 0 1 141.523 64.143)",
    fill: "#513520",
    r: 16.59
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M239.355 58.775c-5.733 57.943-74.898 27.69-78.07 0 0-21.558 17.477-39.035 39.035-39.035 21.559 0 39.035 17.477 39.035 39.035Z",
    fill: "#000"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 93.34,
    cy: 47.797,
    rx: 44.036,
    ry: 44.158,
    fill: "#513520"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 191.781,
    cy: 50.724,
    rx: 44.402,
    ry: 44.403,
    fill: "#000"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.805,
    cy: 58.775,
    fill: "#FFEFE6",
    r: 40.255
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M134.692 58.897c0 22.232-15.339 37.206-37.57 37.206-22.233 0-40.256-18.023-40.256-40.255 0-22.233 18.023-40.255 40.255-40.255 22.232 0 37.571 21.072 37.571 43.304ZM238.062 59.836c.991 7.188-4.033 13.819-11.221 14.81l-3.222-19.896c4.27-7.685 13.453-2.102 14.443 5.086Z",
    fill: "#FFEFE6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M191.415.954c23.243 0 42.085 18.788 42.085 41.963h-84.169c0-23.175 18.842-41.963 42.084-41.963Z",
    fill: "#DBC0B0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M191.415.954c23.243 0 42.085 18.788 42.085 41.963h-84.169c0-23.175 18.842-41.963 42.084-41.963Z",
    fill: "url(#il_error_280px_svg__c)",
    fillOpacity: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M221.242 46.367a.51.51 0 0 1-.105-.292c-.259-9.018-4.374-13.379-12.078-21.074-.358-.357-.005-.958.48-.815l22.388 6.597a.467.467 0 0 1 .341.39c.813 6.689-1.103 24.34-3.294 32.498-.134.497-.799.427-.871-.083-1.038-7.394-2.489-11.594-6.861-17.22ZM188.259 61.01c.479-1.754 2.033-1.846 3.788-1.366 1.754.48 3.045 1.35 2.565 3.105a3.293 3.293 0 1 1-6.353-1.738ZM114.58 61.499c.48-1.755 2.034-1.847 3.788-1.367 1.755.48 3.046 1.35 2.566 3.104a3.294 3.294 0 0 1-6.354-1.737ZM175.326 61.17c-.48-1.754-2.034-1.846-3.788-1.366-1.755.48-3.046 1.35-2.566 3.104a3.294 3.294 0 0 0 6.354-1.738ZM101.647 61.658c-.48-1.754-2.034-1.846-3.789-1.367-1.754.48-3.045 1.35-2.565 3.105a3.294 3.294 0 0 0 6.354-1.738Z",
    fill: "#000"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M177.387 73.047c2.196-2.561 6.587-2.44 8.783 0M103.952 74.801c2.196-2.561 6.587-2.44 8.783 0",
    stroke: "#E5AFAC",
    strokeWidth: 1.464,
    strokeLinecap: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.906,
    cy: 17.932,
    rx: 13.906,
    ry: 17.932,
    transform: "rotate(26.572 41.874 186.368)",
    fill: "#513520"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.59,
    cy: 3.416,
    rx: 16.59,
    ry: 3.416,
    transform: "rotate(40.919 39.407 150.465)",
    fill: "#513520"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.893,
    cy: 39.258,
    fill: "#513520",
    r: 16.59
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.893,
    cy: 39.258,
    fill: "#513520",
    r: 16.59
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.579,
    cy: 26.083,
    fill: "#513520",
    r: 11.223
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 59.062,
    cy: 59.263,
    fill: "#513520",
    r: 16.59
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 59.062,
    cy: 81.708,
    fill: "#513520",
    r: 16.59
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.086,
    cy: 99.762,
    fill: "#513520",
    r: 16.59
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M199.345 74.64c0 2.287-1.912 4.14-4.27 4.14-2.358 0-4.269-1.853-4.269-4.14 0-3.581 2.444-6.635 3.634-7.91a.837.837 0 0 1 1.253.016c1.184 1.325 3.652 4.495 3.652 7.894ZM98.341 73.664c0 2.287-1.911 4.14-4.27 4.14-2.357 0-4.269-1.853-4.269-4.14 0-3.581 2.444-6.635 3.634-7.91a.838.838 0 0 1 1.254.016c1.183 1.325 3.651 4.495 3.651 7.894Z",
    fill: "#97CFFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M105.824 60.99a5.855 5.855 0 0 0-5.606-6.095l-8.942-.373a5.855 5.855 0 0 0-6.094 5.606l-.106 2.535a8.783 8.783 0 0 0 8.41 9.141l3.09.13a8.783 8.783 0 0 0 9.142-8.41l.106-2.535ZM109.076 61.151a5.855 5.855 0 0 1 5.606-6.094l8.531-.356a5.855 5.855 0 0 1 6.094 5.606l.092 2.194a8.783 8.783 0 0 1-8.409 9.141l-2.682.112a8.783 8.783 0 0 1-9.141-8.409l-.091-2.194Z",
    stroke: "#000",
    strokeWidth: 1.952
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M55.488 58.16c-.99 7.188 4.034 13.818 11.222 14.809l3.222-19.896c-4.27-7.685-13.453-2.102-14.444 5.087Z",
    fill: "#FFEFE6"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.399,
    cy: 62.862,
    rx: 4.646,
    ry: 12.726,
    transform: "rotate(10.428 67.399 62.862)",
    fill: "#513520"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 98.277,
    y: 102.446,
    width: 87.713,
    height: 58.922,
    rx: 6.404,
    fill: "#202020"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 98.277,
    y: 102.446,
    width: 87.713,
    height: 58.922,
    rx: 6.404,
    fill: "url(#il_error_280px_svg__d)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 94.036,
    y: 159.136,
    width: 96.195,
    height: 8.928,
    rx: 4.464,
    fill: "#202020"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M147.074 30.43a4.85 4.85 0 0 1 3.869-4.01c31.342-6.008 50.329-5.951 81.669.004a4.85 4.85 0 0 1 3.878 4.012l1.824 11.518c.516 3.257-2.284 6.076-5.55 5.623-31.425-4.352-51.364-4.302-81.956-.013-3.269.458-6.074-2.362-5.557-5.623l1.823-11.512Z",
    fill: "#DBC0B0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m131.17 143.11-.231.348c-.231.347.099.796.501.686 2.765-.757 5.192-1.21 7.496-1.415.28-.025.47-.295.428-.572a5.47 5.47 0 0 1 .037-1.827c.442-2.362 2.274-4.002 4.091-3.662 1.817.34 2.932 2.531 2.49 4.894a5.628 5.628 0 0 1-.161.651c-.091.29.094.607.396.642 2.409.273 4.94.752 7.846 1.369.407.086.706-.384.458-.718-3.268-4.418-5.23-8.259-7.275-12.261-1.472-2.882-2.988-5.848-5.065-9.174-.22-.352-.761-.232-.828.178-1.201 7.365-4.205 11.879-10.183 20.861Z",
    fill: "#79C1FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M105.66 61.215h3.416v1.708h-3.416z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "il_error_280px_svg__a",
    x1: 199.588,
    y1: 81.31,
    x2: 199.588,
    y2: 109.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C48A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#DBC0B0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "il_error_280px_svg__b",
    x1: 84.041,
    y1: 77.073,
    x2: 84.041,
    y2: 105.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C48A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#DBC0B0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "il_error_280px_svg__c",
    x1: 193.733,
    y1: 4.37,
    x2: 191.415,
    y2: 42.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.248,
    stopColor: "#513520",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#513520"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "il_error_280px_svg__d",
    x1: 142.134,
    y1: 102.446,
    x2: 142.134,
    y2: 161.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#202020",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1C1C"
  })))));
};
export default SvgIlError280Px;